import * as yup from 'yup';

/**
 * Use at your own risk.
 * This issue is still open for yup-types
 */

// @ts-ignore
export const dateSchema: yup.SchemaOf<Date> = yup.date();
